export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.ttf?c3146b3524e97475c094343e848a7370";